import React, { useState } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import moment from 'moment';
import { Container } from './styles';

const VALUE_FORMAT = 'YYYY-MM-DD';

interface AiManagementDeadlineFilterProps {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
}

const AiManagementDeadlineFilter: React.FC<AiManagementDeadlineFilterProps> = ({
  from,
  to,
  onChange,
}) => {
  const [focusedInput, setFocusedInput] = useState<FocusedInputShape | null>(null);

  return (
    <Container
      className={`d-flex align-items-center flex-shrink-0 bg-white border rounded px-2 ${
        from || to ? 'border-primary' : ''
      }`}
    >
      <i className="material-icons text-secondary mr-2">event</i>
      <span className="deadline-label mr-1">Prazo:</span>
      <DateRangePicker
        startDate={from ? moment(from, VALUE_FORMAT) : null}
        startDateId="ai_management_deadline_from"
        endDate={to ? moment(to, VALUE_FORMAT) : null}
        endDateId="ai_management_deadline_to"
        onDatesChange={({ startDate, endDate }) =>
          onChange(
            startDate ? startDate.format(VALUE_FORMAT) : '',
            endDate ? endDate.format(VALUE_FORMAT) : '',
          )
        }
        focusedInput={focusedInput}
        onFocusChange={setFocusedInput}
        startDatePlaceholderText="dd/mm/aaaa"
        endDatePlaceholderText="dd/mm/aaaa"
        customArrowIcon={<span className="deadline-label">até</span>}
        minimumNights={0}
        hideKeyboardShortcutsPanel
        displayFormat="DD/MM/YYYY"
        isOutsideRange={() => false}
        showClearDates
        small
        numberOfMonths={1}
        anchorDirection="right"
      />
    </Container>
  );
};

export default AiManagementDeadlineFilter;
